import useFeature from '@/contexts/FeatureFlags/useFeature';

/**
 * The one key that governs every Nedarim draft. Must match FeatureFlagKeys.NedarimDrafts on the
 * server and the row set up by RenameFlag_NedarimDrafts.sql.
 *
 * ⚠️ One key for the support request and the new supported alike. They are the same bargain -
 * fill it in in front of the person, attach the documents here - and a coordinator who has met
 * it once has met it everywhere; releasing one and not the other would teach them that Nedarim
 * can start one kind of form and not another, for no reason they can see.
 */
export const NEDARIM_DRAFTS_FEATURE_KEY = 'nedarim-drafts';

/**
 * Whether the drafts half of the journey is on for the current user, on the site.
 *
 * The same key is read by the Nedarim Plus personal area, but through that flag's *other* release
 * state - the two clients are released independently (see FeatureFlag.NedarimLifecycleStatus).
 * That asymmetry is the point here: a coordinator fills the form in in Nedarim, and this side is
 * what lets them finish it. Until Nedarim is live there are no drafts to list, so this side ships
 * closed while the Nedarim side ships open.
 *
 * Off is the safe answer and the one given whenever anything is missing - the flag row, the
 * ruleset, the provider - because the button it hides only ever leads to an empty list.
 */
export default function useNedarimDraftsFeature(): boolean {
  return useFeature(NEDARIM_DRAFTS_FEATURE_KEY);
}
